// extracted by mini-css-extract-plugin
export default {"header":"fouDHo0OBEd","item":"fouLXquIgjO","content":"fouOxWf0kK0","arrow":"founRIeWvu8"};